import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { usePDPContext } from '~/utilities/context/static/PDPContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { SiteType, SizeGuideUnit } from '~/utilities/graphql/codegen';

const GstarModelWearsStyle = css``;

const AafModelWearsStyle = css`
  margin: 12px 0;
`;

const ModelWearsConfig: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GstarModelWearsStyle,
  [SiteType.Wahts]: GstarModelWearsStyle,
  [SiteType.Outlet]: GstarModelWearsStyle,
  [SiteType.Employeeshop]: GstarModelWearsStyle,
  [SiteType.Aaf]: AafModelWearsStyle,
};

const S = {
  ModelWears: styled.p`
    color: ${({ theme }) => theme.colors.content.primary};
    font-size: ${({ theme }) => theme.font.size[2]};
    line-height: 1.4;
    text-align: left;
    ${({ theme }) => ModelWearsConfig[theme.siteType]};
  `,
};

export const ModelWearsDescription = () => {
  const {
    configuration: { sizeGuideUnit },
  } = useStaticContext();
  const {
    product: { mannequin },
  } = usePDPContext();
  const isModelWearsPresent = Boolean(
    (sizeGuideUnit === SizeGuideUnit.Inch && mannequin?.imperialMessage) ||
      (sizeGuideUnit === SizeGuideUnit.Cm && mannequin?.metricMessage) ||
      mannequin?.additionalSizeInfo
  );

  if (!isModelWearsPresent) {
    return <></>;
  }

  const mannequinMessage =
    sizeGuideUnit === SizeGuideUnit.Inch ? mannequin?.imperialMessage : mannequin?.metricMessage;

  const modelWearsMessage = mannequinMessage
    ? `${mannequinMessage.replace('(', '<br/>(')}&nbsp;${mannequin?.additionalSizeInfo || ''}`
    : `${mannequin?.additionalSizeInfo || ''}`;

  return (
    <S.ModelWears
      data-testid="model-size-message"
      data-cs-capture=""
      dangerouslySetInnerHTML={{
        __html: modelWearsMessage,
      }}
    />
  );
};
